
























import {Component, Vue} from "vue-property-decorator";
// @ts-ignore
import store from "../../store";
import {Player} from "../../../types";
// @ts-ignore
import Tools from "../../helpers/Tools";
import MessageHelper from "../../helpers/MessageHelper";
import EventApi from "../../api/EventsApi";

@Component({
    props: {
        player: {
            required: true,
            type: Object
        },
        isPlayerSettingsVisible: {
            required: true,
            type: Boolean
        }
    },
})

export default class PlayerSettings extends Vue{
    private player!: Player;

    mounted() {
        EventApi.addEventListener(EventApi.EXIT_SEAT, this.exitFromSeat);
    }

    beforeDestroy() {
        EventApi.removeEventListener(EventApi.EXIT_SEAT, this.exitFromSeat);
    }

    /**
     * ID игрока
     * @private
     */
    private get playerId(): string
    {
        return store.getters.getPlayerId;
    }

    /**
     * Изменить иконку игрока
     */
    private changePlayerIcon(icon: string)
    {
        Tools.runTimer('changePlayerIcon', () => {
            const data = {
                playerId: this.player.id,
                icon: icon
            };
            MessageHelper.changePlayerIconMessage(data);
        });
    }

    /**
     * Изменить баллы игрока
     */
    private changePlayerPoints(points: string)
    {
        Tools.runTimer('changePlayerPoints', () => {
            const data = {
                playerId: this.player.id,
                points: points
            };
            MessageHelper.changePlayerPointsMessage(data);
        });
    }

    /**
     * Закрыть настройки сита игрока
     */
    private closePlayerSettings(): void
    {
        this.$emit('closePlayerSettings');
    }

    /**
     * Данные игрока
     * @return {null|*}
     */
    private getPlayerData()
    {
        if (typeof store.getters.getGameState.playersData === "undefined") {
            return null;
        }

        let playersData = store.getters.getGameState.playersData;

        if (typeof playersData[this.player.id] === "undefined") {
            return null;
        }

        return playersData[this.player.id];
    }

    /**
     * Очки игрока
     */
    private getPlayerPoints(): number
    {
        let playerData = this.getPlayerData();

        if (!playerData || !playerData.points) {
            return 0;
        }

        return playerData.points;
    }

    /**
     * Выйти из сита и стать гостем
     */
    private exitFromSeat(): void
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        this.$emit('become-guest');
    }
}
